module.exports = __webpack_public_path__ + "static/media/boat.13a31e83.jpg";